import { render, staticRenderFns } from "./OKAPImap.vue?vue&type=template&id=1d2cfe4b&scoped=true"
import script from "./OKAPImap.vue?vue&type=script&lang=js"
export * from "./OKAPImap.vue?vue&type=script&lang=js"
import style0 from "./OKAPImap.vue?vue&type=style&index=0&id=1d2cfe4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2cfe4b",
  null
  
)

export default component.exports